import styled from "styled-components";

export const LandingPage = styled.div`
  min-height: 100vh;
`;

export const MainContent = styled.main`
  display: block;
`;
